import { PROVIDERS, getProviderEnabled } from '@exodus/fiat-client'
import xopayProvider, { getWidgetUrl as getXopayWidgetUrl } from '@exodus/fiat-client/xo-pay'

const createProvider = ({
  assets,
  config,
  enabled,
  kyc,
  trustScore = Number.POSITIVE_INFINITY,
  trustScoreThreshold = 0,
  ...options
} = {}) =>
  xopayProvider({
    ...options,
    enabled: (args) => {
      if (trustScore < trustScoreThreshold) {
        return false
      }

      return getProviderEnabled({ ...args, enabled, kyc, provider: PROVIDERS.xopay })
    },
    url: config.URL,
  })

export const getWidgetUrl = ({ config, ...options }) =>
  getXopayWidgetUrl({ ...options, url: config.URL })

export default createProvider
